module.exports = __webpack_public_path__ + "img/EOS.d6adc168.png";